import {
  createStandardAction,
  ActionType,
  createReducer,
} from 'typesafe-actions';
import produce from 'immer';
import {FileEntity} from 'lib/api/vodInfo';

/**
 * 현재 재생중인 파일 아이템 리덕스로 관리
 */

export type TFileState = {
  playingIdx: number;
  list: FileEntity[];
  isChatSeek: boolean;
};

type TChangeFile = {
  idx: number;
  url: string;
};

const INIT_LIST = 'file/INIT_LIST';
const CHANGE_PLAYING_IDX = 'file/CHANGE_PLAYING_IDX';
const CHANGE_FILE = 'file/CHANGE_FILE';
const CHANGE_SEEK_CHAT = 'file/CHANGE_SEEK_CHAT';

export const setInitListAction =
  createStandardAction(INIT_LIST)<FileEntity[]>();
export const changePlayingIdxAction =
  createStandardAction(CHANGE_PLAYING_IDX)<number>();
export const setChangeFileAction =
  createStandardAction(CHANGE_FILE)<TChangeFile[]>();
export const changeSeekChatAction =
  createStandardAction(CHANGE_SEEK_CHAT)<boolean>();

type actions = {
  setInitListAction: typeof setInitListAction;
  changePlayingIdxAction: typeof changePlayingIdxAction;
  setChangeFileAction: typeof setChangeFileAction;
  changeSeekChatAction: typeof changeSeekChatAction;
};
type FileAction = ActionType<actions>;

const initialState: TFileState = {
  playingIdx: 0,
  list: [
    {
      file_idx: 0,
      grade: 0,
      hide: 'N',
      file_start: '',
      duration: 0,
      duration_ms: 0,
      file_path: '',
      file_size: 0,
      file_order: 1,
      file_info_key: '',
      vod_url: '',
    },
  ],
  isChatSeek: false,
};

const file = createReducer<TFileState, FileAction>(initialState, {
  [INIT_LIST]: (state, {payload: filesInfo}) =>
    produce(state, (draft) => {
      filesInfo.map((file, idx) => {
        draft.list[idx] = file;
      });
    }),
  [CHANGE_PLAYING_IDX]: (state, {payload: idx}) =>
    produce(state, (draft) => {
      draft.playingIdx = idx;
    }),
  [CHANGE_FILE]: (state, {payload: files}) =>
    produce(state, (draft) => {
      files.map((file) => {
        draft.list[file.idx].vod_url = file.url;
      });
    }),
  [CHANGE_SEEK_CHAT]: (state, {payload: isChatSeek}) =>
    produce(state, (draft) => {
      draft.isChatSeek = isChatSeek;
    }),
  // fileIdx: payload.fileIdx,
  // fileInfoKey: payload.fileInfoKey,
  // url: payload.url,
  // duration: payload.duration,
  // [key]: value,
});

export default file;
